import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  RELOAD_ENTRIES: "relaod_entries",
  SET_ENTRIES_LOADED: "set_entries_loaded",
  SET_FILTER_ENTRY: "set_filter_entry",
  RELOAD_ENTRIES_BY_FILTER: "reload_entries_by_filter"
};
export const INITIAL_STATE = {
  entries: {

    filter: {
      warehouse_id: null,
      types_detail: [],
      status_ids: [],
      created_at: null,
      date_movement: null,
      order_number: "",
      nit: "",
      provider: "",
      limit: 20,
      page: 1,
    },
    rows: 0,
    elements: [],
    status: STATUS_NOT_LOADED,
  },
};

export const entriesReducer = (state, action) => {
  const { RELOAD_ENTRIES, SET_ENTRIES_LOADED, SET_FILTER_ENTRY, RELOAD_ENTRIES_BY_FILTER } = types;
  switch (action.type) {
    case RELOAD_ENTRIES:
      return {
        ...state,
        entries: { ...state.entries, status: STATUS_NOT_LOADED },
      };
    case SET_ENTRIES_LOADED:
      return {
        ...state,
        entries: {
          ...state.entries,
          status: LOADED,
          elements: action.payload.elements,
          rows: action.payload.rows
        },
      };
    case SET_FILTER_ENTRY:
      return {
        ...state,
        entries: {
          ...state.entries,
          filter: {
            ...state.entries.filter,
            [action.payload.field]: action.payload.value,
          },
        },
      };
    case RELOAD_ENTRIES_BY_FILTER:
      return {
        ...state,
        entries: {
          ...state.entries,
          status: STATUS_NOT_LOADED,
          filter: {
            ...state.entries.filter,
            page: 1,
          },
        },
      };

  }
};
